import { render } from "./SafeMode.vue?vue&type=template&id=5f0df2ae&scoped=true"
import script from "./SafeMode.vue?vue&type=script&setup=true&lang=js"
export * from "./SafeMode.vue?vue&type=script&setup=true&lang=js"

import "./SafeMode.vue?vue&type=style&index=0&id=5f0df2ae&scoped=true&lang=css"

import exportComponent from "/Users/lukmannakib/.codex/worktrees/a2d0/debug-log-config-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0df2ae"],['__file',"resources/views/SafeMode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f0df2ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f0df2ae', __exports__)) {
    console.log('reload')
    api.reload('5f0df2ae', __exports__)
  }
  
  module.hot.accept("./SafeMode.vue?vue&type=template&id=5f0df2ae&scoped=true", () => {
    console.log('re-render')
    api.rerender('5f0df2ae', render)
  })

}


export default __exports__